import { h } from 'preact';
import clsx from 'clsx';
import ClickSelection from '../../threekit-components/click-selection';
import { useThreekit } from '../../threekit-context';
import Image from '../../../utils/image';

function HardwareDrawerLiner() {
  const { getProductsFromAttribute, getSelectedVariant, darkMode } = useThreekit();

  const products = getProductsFromAttribute('Liner Color');
  const selectedVariant = getSelectedVariant(products);

  return (
    <div className="laptop:pt-5 laptop:px-5 pl-2.5 py-2.5 flex gap-2.5 items-center justify-center">
      {products.map((product) =>
        product.variants.edges.map(
          (variant) =>
            variant.node.configurationEnabled && (
              <ClickSelection
                key={`${variant.node.id}-liner`}
                element="button"
                variant={variant}
                className={clsx(
                  'border-black border-opacity-20 border-2 max-h-[130px]',
                  {
                    'border-white border-opacity-100':
                      selectedVariant === variant && darkMode,
                    'border-black border-opacity-100':
                      selectedVariant === variant && !darkMode,
                  },
                )}
              >
                <Image
                  {...variant.node.image}
                  width={135}
                  alt={
                    variant.node.image.alt
                      ? variant.node.image.alt
                      : variant.node.title
                  }
                />
              </ClickSelection>
            ),
        ),
      )}
    </div>
  );
}

export default HardwareDrawerLiner;
